import { render } from "./BusinessPage.vue?vue&type=template&id=0170c3f2&scoped=true"
import script from "./BusinessPage.vue?vue&type=script&lang=js"
export * from "./BusinessPage.vue?vue&type=script&lang=js"

import "./BusinessPage.vue?vue&type=style&index=0&id=0170c3f2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0170c3f2"]])

export default __exports__